/* eslint-disable no-console */
const showLogs = () => document.location.search.includes('_showWalletLogs');

export function ddcLog(...args) {
	if (showLogs()) {
		console.log('[MyWallet]', ...args);
	}
}

export const markPerformance = (label) => {
	if (showLogs()) {
		window.performance.mark(label);
	}
}

export const measurePerformance = (label, start, end) => {
	if (showLogs() && !!window.performance.getEntriesByName(label).length) {
		const measurement = window.performance.measure(label, start, end);
		ddcLog(label, measurement.duration);
		window.performance.clearMarks(start);
		window.performance.clearMarks(end);
		window.performance.clearMeasures(label);
	}
}
